import { useEffect, useRef } from "react";
import { Button } from "../ui";

// Building blocks shared by the welcome screen, Common questions and the guided request: the same
// chat panel and bubble styling everywhere. Everything is rendered from state (no timers), so a
// re-render can never repeat a question; new bubbles fade in with CSS only.

export function Assistant({ g, children, tone, label, className = "" }) {
  return (
    <div className="lc-row assistant">
      <div className={`lc-flow-bubble bot ${tone === "error" ? "error" : ""} ${className}`} role={tone === "error" ? "alert" : undefined}>
        <span className="lc-flow-who">{label || g.assistantName}</span>
        {children}
      </div>
    </div>
  );
}

export function UserBubble({ g, children, className = "" }) {
  return (
    <div className="lc-row user">
      <div className={`lc-flow-bubble me ${className}`}>
        <span className="lc-flow-who">{g.youName}</span>
        {children}
      </div>
    </div>
  );
}

export function QuickReplies({ children, label }) {
  return (
    <div className="lc-quick" role="group" aria-label={label}>
      {children}
    </div>
  );
}

// A quick reply is the shared Button (pill shaped); `primary` = filled, otherwise outlined.
export function Quick({ onClick, children, disabled, icon, primary = false, badge, ...rest }) {
  return (
    <Button
      variant="primary"
      appearance={primary ? "filled" : "outline"}
      rounded
      className="lc-quick-btn"
      icon={icon}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
      {badge > 0 && <span className="lc-quick-badge" aria-hidden="true">{badge > 9 ? "9+" : badge}</span>}
    </Button>
  );
}

// Scrolling chat area; keeps the newest bubble in view when `scrollKey` changes.
export function Flow({ g, children, footer, scrollKey }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [scrollKey]);
  return (
    <div className="lc-flow-wrap">
      <div className="lc-flow" ref={ref} role="log" aria-live="polite" aria-relevant="additions" aria-label={g.chatLog}>
        {children}
      </div>
      {footer}
    </div>
  );
}
